export enum TAppTableCol {
  Default,
  Action,
  Hidden,
}
